import React, { useMemo } from "react";
import styled from "styled-components";
import { CompanyNewsItem } from "../../../models/newsModels";
import { lightGreyOutline } from "../../../styles";
import { NewsTimelineRow } from "./NewsTimelineRow";
import { groupByDay } from "./utils";

type NewsTimelineProps = {
  items: CompanyNewsItem[];
  compact: boolean;
};

const List = styled.div<{ $compact: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  &::before {
    content: "";
    position: absolute;
    top: 12px;
    bottom: 12px;
    left: ${({ $compact }): string => ($compact ? "41.5px" : "51.5px")};
    width: 1px;
    background-color: ${lightGreyOutline};
  }
`;

export const NewsTimeline = ({
  items,
  compact,
}: NewsTimelineProps): JSX.Element => {
  const groups = useMemo(() => groupByDay(items), [items]);
  return (
    <List $compact={compact}>
      {groups.flatMap((group) =>
        group.items.map((item, index) => (
          <NewsTimelineRow
            key={item.prepared_evidence_id}
            item={item}
            showDate={index === 0}
            compact={compact}
          />
        )),
      )}
    </List>
  );
};
